import { render, staticRenderFns } from "./FormTemplateQuestionDetail.vue?vue&type=template&id=6aa2d792&scoped=true&"
import script from "./FormTemplateQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./FormTemplateQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateQuestionDetail.vue?vue&type=style&index=0&id=6aa2d792&prod&lang=scss&scoped=true&"
import style1 from "./FormTemplateQuestionDetail.vue?vue&type=style&index=1&id=6aa2d792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2d792",
  null
  
)

export default component.exports